<!-- <div class="container-fluid newlogin">

  <div class="row">
    <div class="col-md-6 bglogin pt-3">

      
      <img src="../../../../assets/images/emplogin.jpg" alt="" height="50%"  style="position: absolute; top: 20%; transform: (-50%, -50%); width: 49%;">
    </div>


    <div class="col-md-6 my-auto">
      <div class="col-md-6 mx-auto ">
        <img src="/../../../assets/logo/EM Proc New Logo.png" alt="" height="80px">
        <form name="loginForm" (ngSubmit)="loginForm.valid  && loginUser()" #loginForm="ngForm" novalidate>
          
          <label class="control-label">User Name</label>
          <div class="form-group login-formgroup-v">
            <input type="text" class="form-control" name="empCode" id="empCode" [(ngModel)]="login.emp_code"
              (ngModelChange)="login.emp_code = login.emp_code?.trim()"  #empCode="ngModel" required  [ngClass]="{ 'is-invalid': loginForm.submitted && empCode.errors }">
              <div *ngIf="loginForm.submitted && empCode.errors" class="invalid-feedback">
                <div *ngIf="empCode.errors['required']">Employee code is required</div>
            </div>
          </div>
          <br><br>
          <label class="control-label">Password</label>

          <div class="form-group" id="password-container" style="position: relative;">
            <input [type]="show_button ? 'text' : 'password'" class="form-control" name="password" id="password"
              [(ngModel)]="login.password"   #password="ngModel" required  [ngClass]="{ 'is-invalid': loginForm.submitted && password.errors }">
            <span
              style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); cursor: pointer; color: rgb(153, 132, 97); font-size: 18px;"
              title="View Password">
              <i [ngClass]="show_button ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'" (click)="showPassword()"></i>
            </span>

            <div *ngIf="loginForm.submitted && password.errors" class="invalid-feedback">
              <div *ngIf="password.errors['required']">Password is required</div>
           </div>
          </div>

          <button type="submit" class="btn btn-primary newloginbtn  btn-block  mt-4">Login</button>
          <div class="text-center mt-2 ">
           or 
          </div>
          <button type="submit" class="btn btn-primary newloginbtn btn-block mt-2 ">Vendor Login </button>
        </form>

      </div>
    </div>
  </div>

</div> -->

<section class="vh-100 backs-image">
  <div class="container h-100">
    <div class="row d-flex h-100">
      <div class="col col-xl-10 m-auto">
        <div class="login-background">
          <div class="row">
            <div class="col-md-6 col-lg-5 d-none d-md-block triangle">
              <img src="../../../../assets/images/triangle.png" alt="login form" class="img-fluid" />
            </div>

            <div class="col-md-6 col-lg-7 card text_side_right">
              <div class="card-body text-black">
                <img src="../../assets/logo/image (3).png" style="height: 100px; width: 200px;" class="img-fluid" />
                <form name="loginForm" (ngSubmit)="loginForm.valid" #loginForm="ngForm" novalidate>

                  <label class="control-label">User Name</label>
                  <div class="form-group login-formgroup-v input-container" style="margin-top: 5px;">
                    <i class="fa fa-user icon"></i>
                    <input type="text" class="form-control" name="user_name" id="user_name"
                      [(ngModel)]="login.user_name" (ngModelChange)="login.user_name = login.user_name?.trim()"
                      #user_name="ngModel" required
                      [ngClass]="{ 'is-invalid': loginForm.submitted && user_name.errors }">
                    <div *ngIf="loginForm.submitted && user_name.errors" class="invalid-feedback">
                      <div *ngIf="user_name.errors['required']">Employee code is required</div>
                    </div>
                  </div>
                  <br>
                  <label class="control-label">Password</label>
                  <div class="form-group input-container" id="password-container"
                    style="position: relative; margin-top: 5px;">
                    <i class="fa fa-key icon"></i>
                    <input [type]="show_button ? 'text' : 'password'" class="form-control" name="password" id="password"
                      [(ngModel)]="login.password" #password="ngModel" required
                      [ngClass]="{ 'is-invalid': loginForm.submitted && password.errors }">
                    <span
                      style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); cursor: pointer; color: rgb(153, 132, 97); font-size: 18px;"
                      title="View Password">
                      <i [ngClass]="show_button ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"
                        (click)="showPassword()"></i>
                    </span>

                    <div *ngIf="loginForm.submitted && password.errors" class="invalid-feedback">
                      <div *ngIf="password.errors['required']">Password is required</div>
                    </div>
                  </div>
                  <span style="cursor: pointer; color: blue;" (click)="forgotPassword()">Forgot password</span>
                  <div class="loginVendorButton">
                    <button type="button" class="btn btn-primary newloginbtn  btn-block"
                      (click)="loginUser()">Login</button>
                    <!-- <div *ngIf="countdownEnded" class="alert alert-danger">
                      Your trial period has expired. Please contact support for further assistance.
                    </div> -->
                    <div class="text-center">
                      or
                    </div>
                    <button type="button" class="btn btn-primary newloginbtn btn-block" (click)="loginVendor()">Vendor
                      Login </button>
                    <div class="text-center">
                      or
                    </div>
                    <button type="button" class="btn btn-primary newloginbtn btn-block" (click)="GuestUser()">Guest User
                      Signup
                    </button>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>